module.exports = __webpack_public_path__ + "img/marmelaedchen-regal_xs.0a71f63b.jpg";